import { DeclarationHighValueGroupType } from '@e-origin/shared';

import { Variant } from '../types';

const H2 = DeclarationHighValueGroupType.H2;

export const frExport: Variant = {
  loadingPlaceIdentity: { present: true },

  'goodShipmentGlobal.customsProcedureType': { present: true },
  'goodShipmentGlobal.customsNationalProcedure': { present: true },
  'goodShipmentGlobal.customsNationalProcedureCode': { present: true },

  'messageInfo.methodOfPayment': { amendmentLocked: true },
  'messageInfo.deferredPayment': { amendmentLocked: true },
  'messageInfo.methodOfPaymentVAT': { amendmentLocked: true },
  'messageInfo.security': { present: true },

  // No override needed at all here beyond `code` - base's own `rules: [B2B_NOT_H2]` already governs
  // presence (B2B, not H2), and FR keeps the base `section` (transport tab).
  'valuationInformationTaxes.deliveryTerms.country': { code: 'CL008' },

  'consignment.countryOfExport': { rules: [{ when: { txClass: ['B2B'] }, then: { present: true } }] },
  'consignment.carrier': { rules: [{ when: { txClass: ['B2B'] }, then: { present: true } }] },
  'consignment.countryOfDestination': { code: 'CL008' },

  'consignment.customsOfficeExit.referenceNumber': { present: true },
  'consignment.customsOfficeExport.referenceNumber': { present: true },
  'consignment.customsSupervisingOffice.referenceNumber': { amendmentLocked: true },
  'consignment.customsOfficePresentation.referenceNumber': { present: true, code: 'CL193' },

  'messageInfo.declarationMainType': { amendmentLocked: true },
  'messageInfo.declarationType': { amendmentLocked: true },

  'transportInformation.departureTransportMeans.identificationNumber': { rules: [{ when: { txClass: ['B2B'] }, then: { present: true } }] },
  'transportInformation.departureTransportMeans.typeOfIdentification': { rules: [{ when: { txClass: ['B2B'] }, then: { present: true } }] },
  'transportInformation.departureTransportMeans.nationality': { rules: [{ when: { txClass: ['B2B'] }, then: { present: true } }] },
  'transportInformation.activeBorderTransportMeans.identificationNumber': { present: true },
  'transportInformation.activeBorderTransportMeans.typeOfIdentification': { present: true },
  'transportInformation.countryOfRoutingOfConsignment': { present: true },
  'transportInformation.modeOfTransportMeansAtTheBorder': { rules: [{ when: { group: H2 }, then: { present: false } }] },
};
